import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../../constants/common'
import { ICON_HEIGHT_20 } from '../../Icon'

import { PROFILE_AI_SUMMARY_WIDGET_WARNING } from './ProfileAISummaryWidget.constants'

import RefreshIcon from '../../../icons/refresh.svg'

function isEmailNotSatisfyingSummaryRequirement({
  canGenerate,
  text,
  warnings,
}) {
  return !canGenerate && !text && warnings?.length === 0
}

export function getNotifications({
  canGenerate,
  isArchived,
  loading,
  t,
  text,
  warnings,
  onGenerateSummary,
}) {
  return [
    ...(warnings?.includes(PROFILE_AI_SUMMARY_WIDGET_WARNING.insufficientTokens)
      ? [
          {
            id: PROFILE_AI_SUMMARY_WIDGET_WARNING.insufficientTokens,
            text: t('Notification.ProfileAISummaryWidgetInsufficientTokensKey'),
            type: NOTIFICATION_TYPE.warning,
          },
        ]
      : EMPTY_LIST),
    ...(isEmailNotSatisfyingSummaryRequirement({ canGenerate, text, warnings })
      ? [
          isArchived
            ? {
                id: PROFILE_AI_SUMMARY_WIDGET_WARNING.emailIsArchived,
                text: t('Notification.ProfileAISummaryWidgetEmailArchivedKey'),
                type: NOTIFICATION_TYPE.warning,
              }
            : {
                id: PROFILE_AI_SUMMARY_WIDGET_WARNING.emailIsNotSatisfyingSummaryRequirement,
                text: t('Notification.ProfileAISummaryWidgetEmailTooShortKey'),
                type: NOTIFICATION_TYPE.warning,
              },
        ]
      : EMPTY_LIST),
    ...(warnings?.includes(
      PROFILE_AI_SUMMARY_WIDGET_WARNING.temporaryUnavailable
    )
      ? [
          {
            id: PROFILE_AI_SUMMARY_WIDGET_WARNING.temporaryUnavailable,
            text: t(
              'Notification.ProfileAISummaryWidgetTemporaryUnavailableKey'
            ),
            type: NOTIFICATION_TYPE.warning,
          },
        ]
      : EMPTY_LIST),
    ...(warnings?.includes(PROFILE_AI_SUMMARY_WIDGET_WARNING.notSummarizable)
      ? [
          {
            id: PROFILE_AI_SUMMARY_WIDGET_WARNING.notSummarizable,
            text: t('Notification.ProfileAISummaryWidgetNotSummarizableKey'),
            type: NOTIFICATION_TYPE.warning,
          },
        ]
      : EMPTY_LIST),
    ...(warnings?.includes(
      PROFILE_AI_SUMMARY_WIDGET_WARNING.someAttachmentsNotProcessed
    )
      ? [
          {
            id: PROFILE_AI_SUMMARY_WIDGET_WARNING.someAttachmentsNotProcessed,
            text: t(
              'Notification.ProfileAISummaryWidgetSomeAttachmentsNotProcessedKey'
            ),
            type: NOTIFICATION_TYPE.info,
          },
        ]
      : EMPTY_LIST),
    ...(canGenerate
      ? [
          {
            actions: [
              {
                beforeIconProps: {
                  Icon: RefreshIcon,
                  height: ICON_HEIGHT_20,
                },
                callback: onGenerateSummary,
                isLoading: loading,
                text: t(
                  'Notification.ProfileAISummaryWidgetRefreshButtonTextKey'
                ),
              },
            ],
            id: 'outdated',
            text: t('Notification.ProfileAISummaryWidgetOutdatedKey'),
            type: NOTIFICATION_TYPE.info,
          },
        ]
      : EMPTY_LIST),
  ]
}
